import * as THREE from "three";

export const default_scale = 100;
export const default_d4_labels = [
  [[], [0, 0, 0], [2, 4, 3], [1, 3, 4], [2, 1, 4], [1, 2, 3]],
  [[], [0, 0, 0], [2, 3, 4], [3, 1, 4], [2, 4, 1], [3, 2, 1]],
  [[], [0, 0, 0], [4, 3, 2], [3, 4, 1], [4, 2, 1], [3, 1, 2]],
  [[], [0, 0, 0], [4, 2, 3], [1, 4, 3], [4, 1, 2], [1, 3, 2]]
];
export const default_d20_labels = [
  " ",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20"
];
export const default_d100_labels = [
  " ",
  "00",
  "10",
  "20",
  "30",
  "40",
  "50",
  "60",
  "70",
  "80",
  "90"
];

export const material_options = {
  specular: 0x172022,
  color: 0xf0f0f0,
  shininess: 40,
  flatShading: THREE.FlatShading
};
export const default_label_color = "#aaaaaa";
export const default_dice_color = "#202020";

export const default_ambient_light_color = "#999999"; // 0x496a93;
export const default_ambient_light_color_dark = "#666666";
export const default_spot_light_color = "#666666"; // 0x496a93;
export const default_spot_light_color_dark = "#333333";
// color of tabletop surface
export const default_desk_color = "#dfdfdf";
export const default_desk_color_dark = "#303030";

export const default_selector_back_colors = {
  color: 0x404040,
  shininess: 0,
  emissive: 0x858787
};

export const dice_face_range = {
  d4: [1, 4],
  d6: [1, 6],
  d8: [1, 8],
  d10: [0, 9],
  d12: [1, 12],
  d20: [1, 20],
  d100: [0, 9]
};
export const dice_mass = {
  d4: 300,
  d6: 300,
  d8: 340,
  d10: 350,
  d12: 350,
  d20: 400,
  d100: 350
};
export const dice_inertia = {
  d4: 5,
  d6: 13,
  d8: 10,
  d10: 9,
  d12: 8,
  d20: 6,
  d100: 9
};

export const DROP_TYPES = {
  LOWEST: `Drop Lowest`,
  HIGHEST: `Drop Highest`,
  NONE: `None`
};

export const CUSTOM_DICE_TYPES = {
  MULTIPLE: `Allow Multiple Dice Types`,
  ONE: `Allow One Die Type`
};

export const RESULT_TYPES = {
  RAW: "Raw Results",
  ADD: "Add Results",
  POOL: "Dice Pool Results",
  PERCENTAGE: "Percentage Results"
};

export const defaultRollOptions = [
  {
    label: `d20 Plus Modifier`,
    dice: [`d20`],
    expectModifier: true,
    drop: DROP_TYPES.NONE,
    dropNumber: 0,
    resultType: RESULT_TYPES.ADD
  },
  {
    label: `Percentage Dice`,
    dice: [`d100`, `d10`],
    expectModifier: false,
    drop: DROP_TYPES.NONE,
    dropNumber: 0,
    resultType: RESULT_TYPES.PERCENTAGE
  },
  {
    label: `4d6 Drop Lowest`,
    dice: [`d6`, `d6`, `d6`, `d6`],
    expectModifier: false,
    drop: DROP_TYPES.LOWEST,
    dropNumber: 1,
    resultType: RESULT_TYPES.ADD
  },
  // {
  //   label: `Custom Roll (Raw Results)`,
  //   dice: CUSTOM_DICE_TYPES.MULTIPLE,
  //   expectModifier: false,
  //   drop: DROP_TYPES.NONE,
  //   dropNumber: 0,
  //   resultType: RESULT_TYPES.RAW
  // },
  {
    label: `Custom Roll (Add Results)`,
    dice: CUSTOM_DICE_TYPES.MULTIPLE,
    expectModifier: true,
    drop: DROP_TYPES.NONE,
    dropNumber: 0,
    resultType: RESULT_TYPES.ADD
  },
  {
    label: `Custom Roll (Dice Pool)`,
    dice: CUSTOM_DICE_TYPES.ONE,
    expectModifier: false,
    drop: DROP_TYPES.NONE,
    dropNumber: 0,
    resultType: RESULT_TYPES.POOL
  }
];
